/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'confluence-analytics-byline.abbreviated-user-views.message': '{count, plural, =0 {Views} one {1} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': 'Viewers',
  'confluence-analytics-byline.user-views.message':
    '{count, plural, =0 {Analytics} one {1 person viewed} other {{count} people viewed}}',
};
